module.exports = __webpack_public_path__ + "static/media/0222_IMG_LES_MURS_METRO_DIAMANTO_BRILLANT_TALCO_CHEVRON.38418f27.png";